import {
	SITES_LOADING, SITES_SUCCESS, SITES_ERROR,
	FILTERS_UPDATE, COMBOS_SUCCESS, TITLES_SUCCESS, TYPES_SUCCESS,
} from '../actions/siteActions';

const today = new Date();
const fmt   = (d) => d.toISOString().split('T')[0];

const initialState = {
	sites:           [],
	loading:         false,
	error:           null,
	_activeFetch:    0,
	networkCombos:   [],
	// featureTypes: [{ id, name, color }] — from TrackerFeature (already filtered/ordered server-side)
	featureTypes:    [],
	// activityTitles: [{ title, hasSites, isClosed }]
	activityTitles:  [],
	filters: {
		technology:     '4G',
		technologies:   ['4G'],
		vendors:        [],
		servers:        [],
		tacs:           [],
		sides:          [],
		activityStatus: 'Open',
		features:       [],
		selectedTitles: [],
		selectedSites:  [],
		siteSearchMode: 'highlight',
		windowStart: fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 90)),
		windowEnd:   fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 90)),
		startDate:   fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 15)),
		endDate:     fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 15)),
	},
};

const siteReducer = (state = initialState, action) => {
	switch (action.type) {
					case SITES_LOADING:
						return { ...state, loading: true, error: null, _activeFetch: action.token };
					case SITES_SUCCESS:
						if (action.token !== state._activeFetch) return state;
						return { ...state, loading: false, sites: action.payload };
					case SITES_ERROR:
						if (action.token !== state._activeFetch) return state;
						return { ...state, loading: false, error: action.payload };
					case FILTERS_UPDATE: {
						const nextFilters = { ...state.filters, ...action.payload };
						// When activityStatus changes manually, strip selectedTitles that don't match the new mode.
						if (action.payload.activityStatus
			    && action.payload.activityStatus !== state.filters.activityStatus
			    && !Object.prototype.hasOwnProperty.call(action.payload, 'selectedTitles')) {
							const targetIsClosed = action.payload.activityStatus === 'Closed';
							const titlesMap      = new Map((state.activityTitles || []).map((t) => [t.title, !!t.isClosed]));
							nextFilters.selectedTitles = (state.filters.selectedTitles || [])
								.filter((t) => titlesMap.has(t) && titlesMap.get(t) === targetIsClosed);
						}
						return { ...state, filters: nextFilters };
					}
					case COMBOS_SUCCESS:
						return { ...state, networkCombos: action.payload };
					case TYPES_SUCCESS:
						return { ...state, featureTypes: action.payload };
					case TITLES_SUCCESS: {
						const raw = action.payload || [];
						const newTitles = raw.map((x) => {
							if (typeof x === 'string') return { title: x, hasSites: true, isClosed: false };
							return {
								title:    x.title    ?? x.Title    ?? '',
								hasSites: x.hasSites ?? x.HasSites ?? false,
								isClosed: x.isClosed ?? x.IsClosed ?? false,
							};
						}).filter((x) => x.title);

						// Drop selectedTitles that no longer exist or have no sites linked
						const validSet     = new Set(newTitles.filter((t) => t.hasSites).map((t) => t.title));
						const prevSelected = state.filters.selectedTitles || [];
						const nextSelected = prevSelected.filter((t) => validSet.has(t));

						return {
							...state,
							activityTitles: newTitles,
							filters: { ...state.filters, selectedTitles: nextSelected },
						};
					}
					default:
						return state;
	}
};

export default siteReducer;